/* A&C - ARTISTS page. Instant search over the A-Z grid.
   Progressive enhancement: with JS off the full list still renders and the
   search box stays hidden. */
(function () {
  'use strict';

  function fold(value) {
    return (value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function init(root) {
    if (!root || root.dataset.acArtistsReady === 'true') return;
    root.dataset.acArtistsReady = 'true';

    var search = root.querySelector('.ac-artists__search');
    var input = root.querySelector('[data-ac-artists-input]');
    var counter = root.querySelector('[data-ac-artists-count]');
    var noResults = root.querySelector('[data-ac-artists-no-results]');

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-ac-artists-card]')).map(function (el) {
      return { el: el, haystack: fold(el.getAttribute('data-ac-artists-name')) };
    });

    initCarousel(root);

    if (search) search.hidden = false;
    if (!input) return;

    function apply() {
      var query = fold(input.value);
      var shown = 0;

      cards.forEach(function (card) {
        var match = query === '' || card.haystack.indexOf(query) !== -1;
        card.el.hidden = !match;
        if (match) shown += 1;
      });

      if (counter) {
        counter.textContent = shown + (shown === 1 ? ' artist' : ' artists');
      }
      if (noResults) noResults.hidden = shown !== 0;
    }

    var timer = null;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(apply, 120);
    });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && input.value !== '') {
        event.stopPropagation(); // Dawn closes drawers/modals on Escape
        input.value = '';
        apply();
      }
    });

    apply();
  }

  /* Featured strip: a scroll-snap track that works on its own. The arrows are
     an enhancement, revealed only when there is actually something to scroll. */
  function initCarousel(root) {
    var track = root.querySelector('[data-ac-artists-track]');
    var prev = root.querySelector('[data-ac-artists-prev]');
    var next = root.querySelector('[data-ac-artists-next]');
    if (!track || !prev || !next) return;

    function overflow() {
      return track.scrollWidth - track.clientWidth;
    }

    function sync() {
      var max = overflow();
      if (max < 8) {
        prev.hidden = true;
        next.hidden = true;
        return;
      }
      prev.hidden = track.scrollLeft < 8;
      next.hidden = track.scrollLeft >= max - 8;
    }

    function page(direction) {
      var slide = track.querySelector('.ac-artists__slide');
      var step = slide ? slide.getBoundingClientRect().width + 18 : track.clientWidth;
      var perView = Math.max(1, Math.floor(track.clientWidth / step));
      track.scrollBy({ left: direction * step * perView, behavior: 'smooth' });
    }

    prev.addEventListener('click', function () { page(-1); });
    next.addEventListener('click', function () { page(1); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  function initAll(scope) {
    Array.prototype.slice
      .call((scope || document).querySelectorAll('[data-ac-artists]'))
      .forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-run when the section is re-rendered.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
